// Used as a unique identifier for the "Create" option within search results.
// Used to help distinguish the "Create" suggestion within the search results in
// order to handle it as a unique case.
export var CREATE_TYPE = '__CREATE__';
//# sourceMappingURL=constants.js.map